<div class="manageroles" [ngClass]="{ bundleScroll: bundleId }">
    <div class="rolesMainDiv">
        <mat-drawer-container class="drawerContainer" autosize>
            <mat-drawer #rolesDrawer class="roleMatDrawer manageRoleMatDrawer" mode="side" disableClose position="end">
                <div class="rolecls">
                    <div class="rolesWidget userMainTableConatiner" [hidden]="!isViewRole && !updateRole && !isAddRole">
                        <div class="settingsHeader" *transloco="let translate">
                            <span *ngIf="isAddRole && !isViewRole" class="settingsNameText" [textContent]="translate('Create Role')"></span>
                            <span
                                *ngIf="updateRole && !isViewRole && !isAddRole"
                                class="settingsNameText"
                                [textContent]="translate('Update Role') + ': ' + rolesObject?.roleName"></span>
                            <span
                                *ngIf="isViewRole && !updateRole && !isAddRole"
                                class="settingsNameText"
                                [textContent]="translate('Role Details') + ': ' + rolesObject?.roleName"></span>
                            <div class="settingsDataActionsContainer">
                                <mat-icon [title]="translate('Close')" class="closeIcon" aria-hidden="true" (click)="cancelView()">
                                    cancel
                                </mat-icon>
                            </div>
                        </div>
                        <perfect-scrollbar
                            class="materialStepperDiv position-relative"
                            [config]="{ suppressScrollY: bundleId ? true : false }">
                            <mat-horizontal-stepper labelPosition="bottom" #rolesStepper linear>
                                <ng-container *transloco="let translate">
                                    <ng-template matStepperIcon="edit" let-index="index"></ng-template>
                                    <mat-step [label]="roleLabel">
                                        <div class="addRoleContainer">
                                            <role-fields [rolesObject]="rolesObject" [errors]="errors"></role-fields>
                                        </div>
                                        <div class="floatRight" [hidden]="bundleId">
                                            <div class="displyInlineBlock cancelButtonDiv">
                                                <material-button
                                                    [text]="translate('Cancel')"
                                                    (buttonClicked)="cancelView()"></material-button>
                                            </div>
                                            <div class="displyInlineBlock buttonsDiv">
                                                <material-button
                                                    [color]="'primary'"
                                                    [text]="translate('Next: Assign Permissions')"
                                                    (buttonClicked)="validateRoleDetails()"></material-button>
                                            </div>
                                        </div>
                                    </mat-step>
                                    <mat-step>
                                        <ng-template matStepLabel>
                                            <span [textContent]="translate('Assign Permissions')"></span>
                                        </ng-template>
                                        <div class="rolePermissionsDiv" *ngIf="totalPermissions">
                                            <role-permissions
                                                [rolePermissionsData]="totalPermissions"
                                                [isCheckboxNeeded]="true"
                                                [isNextClicked]="isNextClicked"></role-permissions>
                                        </div>
                                        <div [hidden]="bundleId">
                                            <div class="displyInlineBlock cancelButtonDiv">
                                                <material-button
                                                    [color]="'primary'"
                                                    matStepperPrevious
                                                    [text]="translate('Back')"
                                                    (buttonClicked)="backToPreviousStep()"></material-button>
                                            </div>
                                            <div class="displyInlineBlock floatRight buttonsDiv">
                                                <material-button
                                                    [color]="'primary'"
                                                    [text]="translate('Next: Review')"
                                                    (buttonClicked)="validateRolePermissions()"></material-button>
                                            </div>
                                            <div class="displyInlineBlock cancelButtonDiv floatRight">
                                                <material-button
                                                    [text]="translate('Cancel')"
                                                    (buttonClicked)="cancelView()"></material-button>
                                            </div>
                                        </div>
                                    </mat-step>
                                    <mat-step>
                                        <ng-template matStepLabel><span [textContent]="translate('Review')"></span></ng-template>
                                        <div class="roleReviewContainer">
                                            <div class="roleReviewHeader" *ngIf="updateRole && !isViewRole">
                                                <span
                                                    class="displayBlock reviewCls"
                                                    [textContent]="translate('Review Role Details')"></span>
                                                <span
                                                    class="displayBlock reviewNoteCls"
                                                    [textContent]="
                                                        translate(
                                                            'Review your choices. After your create the role, you cannot remove it. In case of any changes you need to create another only.'
                                                        )
                                                    "></span>
                                            </div>
                                            <div class="reviewRolerDetailsContainer">
                                                <div class="reviewRoleDetailsSection">
                                                    <ng-container *ngIf="isViewRole && rolesObject">
                                                        <div class="entityFieldContainer col-xs-3 col-3 wordBreak">
                                                            <div class="fieldInReadOnly">
                                                                <div class="readOnlyFieldValues">
                                                                    <div
                                                                        class="readOnlyLabel userViewLabel"
                                                                        title="Role Name"
                                                                        [textContent]="translate('Role Name') + ' :'"></div>
                                                                    <div class="readOnlyValue" [textContent]="rolesObject.roleName"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="entityFieldContainer col-xs-3 col-3 wordBreak">
                                                            <div class="fieldInReadOnly">
                                                                <div class="readOnlyFieldValues">
                                                                    <div
                                                                        class="readOnlyLabel userViewLabel"
                                                                        title="Display Name "
                                                                        [textContent]="translate('Display Name') + ' :'"></div>
                                                                    <div
                                                                        class="readOnlyValue"
                                                                        [textContent]="rolesObject.displayName"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="entityFieldContainer col-xs-3 col-3 wordBreak">
                                                            <div class="fieldInReadOnly">
                                                                <div class="readOnlyFieldValues">
                                                                    <div
                                                                        class="readOnlyLabel userViewLabel"
                                                                        title="Description"
                                                                        [textContent]="translate('Description') + ' :'"></div>
                                                                    <div
                                                                        class="readOnlyValue"
                                                                        [textContent]="rolesObject.description"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                                <div
                                                    class="rolePermission"
                                                    [hidden]="!totalReviewPermissions.value || totalReviewPermissions.value?.length === 0">
                                                    <div class="mt-4">
                                                        <role-permissions
                                                            [rolePermissionsData]="totalReviewPermissions"
                                                            [isCheckboxNeeded]="false"></role-permissions>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div *ngIf="!isViewRole" class="displyInlineBlock buttonsDiv" [hidden]="bundleId">
                                                <material-button
                                                    [color]="'primary'"
                                                    [text]="translate('Back')"
                                                    (buttonClicked)="backToPreviousStep()"></material-button>
                                            </div>
                                            <div class="displyInlineBlock floatRight buttonsDiv" [hidden]="bundleId">
                                                <material-button
                                                    *ngIf="isAddRole && !isViewRole"
                                                    [color]="'primary'"
                                                    [text]="translate('Create Role')"
                                                    (buttonClicked)="submitData()"></material-button>
                                                <material-button
                                                    *ngIf="updateRole && !isViewRole && !isAddRole"
                                                    [color]="'primary'"
                                                    [text]="translate('Update Role')"
                                                    (buttonClicked)="submitData()"></material-button>
                                                <material-button
                                                    *ngIf="
                                                        (isViewRole && !updateRole && rolesObject.roleName !== 'CUSTOMER_ADMIN') ||
                                                        rolesObject.roleName === 'PROVIDER_ADMIN'
                                                    "
                                                    [color]="'primary'"
                                                    [text]="translate('Edit Role')"
                                                    (buttonClicked)="manageRoles(rolesObject, 'edit', 'view')"></material-button>
                                            </div>
                                            <div [hidden]="bundleId" class="displyInlineBlock buttonsDiv cancelButtonDiv floatRight">
                                                <material-button
                                                    [text]="translate('Cancel')"
                                                    (buttonClicked)="cancelView()"></material-button>
                                            </div>
                                        </div>
                                    </mat-step>
                                </ng-container>
                            </mat-horizontal-stepper>
                        </perfect-scrollbar>
                    </div>
                    <ng-container *ngIf="copyRoleBol">
                        <div class="copyRoleFieldsContainer userMainTableConatiner" *transloco="let translate">
                            <div class="settingsHeader">
                                <span class="settingsNameText" [textContent]="translate('Copy Role') + ' : ' + selectedRoleName"></span>
                                <div class="settingsDataActionsContainer">
                                    <mat-icon [title]="translate('Close')" class="closeIcon" aria-hidden="true" (click)="cancelView()">
                                        cancel
                                    </mat-icon>
                                </div>
                            </div>
                            <div class="copyRoleDiv h-[calc(100vh-118px)]" [perfectScrollbar]>
                                <div *ngIf="locations && locations.length > 0" class="copyRoleInformation">
                                    <span [textContent]="translate('Choose all the locations where you want to copy the role.')"></span>
                                </div>
                                <div class="listOfOrgDiv">
                                    <div *ngIf="locations && locations.length > 0">
                                        <div class="selectLocDiv">
                                            <div class="displyInlineBlock">
                                                <span class="selectLocSpan" [textContent]="translate('Select Locations') + ':'"></span>
                                            </div>
                                            <div class="displyInlineBlock searchLocation">
                                                <mat-form-field>
                                                    <mat-label *transloco="let translate">{{ translate('Search Location') }}</mat-label>
                                                    <input
                                                        matInput
                                                        type="text"
                                                        name="searchLocation"
                                                        [(ngModel)]="searchLocation"
                                                        (ngModelChange)="searchLocation = $event"
                                                        (keyup)="searchRelatedLocations()" />
                                                    <material-button
                                                        matSuffix
                                                        [classList]="['selectCloseIcon']"
                                                        *ngIf="searchLocation"
                                                        buttonType="icon"
                                                        size="small"
                                                        [titleText]="'Clear'"
                                                        prefixIconType="material"
                                                        prefixIcon="close"
                                                        (buttonClicked)="
                                                            $event.stopPropagation(); clearSearchLocations()
                                                        "></material-button>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="selectAllDiv" *ngIf="!noRelatedLocations">
                                            <material-checkbox
                                                labelTextClass="!whitespace-normal !break-words"
                                                [(model)]="allLocationsSelected"
                                                [name]="'Select All'"
                                                (modelChange)="selectAllLoctions($event)"
                                                id="selectAllPartnerLoc"
                                                [showName]="true"></material-checkbox>
                                        </div>
                                        <div class="row copyRoleSelectDropdwn">
                                            <div *ngFor="let location of locations | FilterPipe : 'name' : searchLocation" class="col-4">
                                                <div class="form-check searchLocationsList">
                                                    <span class="form-check-label">
                                                        <ul>
                                                            <li class="rolePermissionClass">
                                                                <material-checkbox
                                                                    labelTextClass="!whitespace-normal !break-words"
                                                                    class="selectbox"
                                                                    [(model)]="location.selected"
                                                                    [name]="location.name"
                                                                    [id]="location.id"
                                                                    (modelChange)="checkLocList()"
                                                                    [showName]="true"></material-checkbox>
                                                            </li>
                                                        </ul>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <ng-container *ngIf="searchLocation && noRelatedLocations">
                                        <div class="d-flex justify-content-center noUsersFound">
                                            <span [textContent]="translate('No locations found')"></span>
                                        </div>
                                    </ng-container>
                                    <div class="noLocation" *ngIf="locations?.length === 0">
                                        <span [textContent]="translate('No locations available')"></span>
                                    </div>
                                    <div class="footerRole">
                                        <div class="displyInlineBlock floatRight buttonsDiv">
                                            <material-button
                                                [disabled]="!formValid"
                                                [color]="'primary'"
                                                [text]="translate('Copy Role')"
                                                (buttonClicked)="SubmitCopyRole()"></material-button>
                                        </div>
                                        <div class="displyInlineBlock buttonsDiv cancelButtonDiv floatRight">
                                            <material-button [text]="translate('Cancel')" (buttonClicked)="cancelView()"></material-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="assignUsersBol">
                        <app-users-list
                            [selectedRoleName]="selectedRoleName"
                            [errors]="{ org: [], user: [] }"
                            [partnerOrganizations]="partnerOrganizations"
                            [users]="users"
                            [selectedPartnerOrg]="selectedPartnerOrg"
                            [allUsersSelected]="allUsersSelected"
                            [formValid]="formValid"
                            [noAssignUsers]="noAssignUsers"
                            [searchUser]="searchUser"
                            (searchUserChange)="searchUser = $event"
                            (cancelView)="cancelView()"
                            (selectAllUsers)="selectAllUsers($event)"
                            (clearSearchUsers)="clearSearchUsers()"
                            (assignUsersToLocations)="assignUsersToLocations()"
                            (cancelAssignUsers)="cancelAssignUsers()"
                            (checkUsersList)="checkUsersList()"
                            (searchAssignUsers)="searchAssignUsers()"
                            (selectedPartnerOrgChange)="getOrgUsers($event)"></app-users-list>
                    </ng-container>
                </div>
            </mat-drawer>
            <mat-drawer-content>
                <div class="rolesTableMainDiv">
                    <div class="rolesTableContainer userMainTableConatiner">
                        <div class="settingsHeader" *transloco="let translate">
                            <span class="settingsNameText" [textContent]="translate('Manage Roles')"></span>
                            <div class="settingsDataActionsContainer d-flex align-items-center">
                                <div class="outlookSearchContainer">
                                    <div class="outLookSearchHolder">
                                        <div class="align-items-center d-flex mainSearch">
                                            <div
                                                class="mainSearchSearcher searchBorder cursorPointer d-flex align-items-center justify-content-between">
                                                <span class="material-icons searchIcon">search</span>
                                                <input
                                                    matInput
                                                    type="text"
                                                    [placeholder]="translate('Search')"
                                                    [(ngModel)]="roleSearchValue"
                                                    (keyup)="searchRole(roleSearchValue)" />
                                                <span
                                                    class="material-icons searchIcon pointer"
                                                    *ngIf="roleSearchValue"
                                                    (click)="clearSearch()">
                                                    close
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <mat-icon
                                    [title]="translate('Add Role')"
                                    class="addIcon addIconColor"
                                    aria-hidden="true"
                                    (click)="manageRoles(undefined, 'create-new')">
                                    add_circle
                                </mat-icon>
                            </div>
                        </div>
                        <div class="row m-0 w-100 rolesContainer">
                            <div class="col-12 ps position-relative h-[calc(100vh-133px)]" [perfectScrollbar]>
                                <div class="roleTable noMargin">
                                    <role-table
                                        [roles]="roleTable"
                                        [roleTableColumns]="roleTableColumns"
                                        [hidePaginator]="false"
                                        [hideTableColumns]="hideTableColumns"
                                        [primaryColumns]="primaryColumns"
                                        (copyOfSelectedRole)="copyRole($event)"
                                        (deleteOfSelectedROle)="deleteRole($event)"
                                        (selectedRecord)="manageRoles($event, 'edit')"
                                        [tableNotAvailable]="true"
                                        [bundleId]="bundleId"
                                        (assignUsersToSelectedRole)="assignUsers($event)"
                                        [needRoleActions]="true"
                                        [defaultPaginator]="true"
                                        (viewRoleRecord)="manageRoles($event, 'view')"></role-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-drawer-content>
        </mat-drawer-container>
    </div>
</div>
